module.exports = __webpack_public_path__ + "static/img/background.c3f6b54c.svg";